import { render } from "./UpdateView.vue?vue&type=template&id=2e1fcbd5"
const script = {}

import "./UpdateView.vue?vue&type=style&index=0&id=2e1fcbd5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__